import AmexDiscoveryPrompt from './AmexDiscoveryPrompt';

export default AmexDiscoveryPrompt;
